import classNames from 'classnames';
import { useRef } from 'react';
import { ReactComponent as MenuRight } from 'src/Themes/assets/menu-right.svg';
import { PointType } from '.';
import { Hint } from '@redoc/ui-kit';

interface IButtonProps {
	isWait?: boolean;
	iconClass: string;
	title: string;
	disabled?: boolean;
	color?: string;
	isActive?: boolean;
	isExpanded?: boolean;
	onClick: (position: PointType) => void;
}

/** Кнопка меню электронной очереди */
export const EQMenuButton: React.FC<IButtonProps> = ({
	isActive = false,
	isWait = false,
	iconClass,
	title,
	disabled,
	onClick,
	color,
	isExpanded = false,
}) => {
	const btnRef = useRef<HTMLLIElement>(null);

	/** CSS классы для элемента меню */
	const itemClasses = classNames('menu_item menu_button enter-eq', {
		'menu_item-disabled': disabled,
		active: isActive,
	});

	/** CSS классы для текста кнопки */
	const titleClasses = classNames('menu_item-text', {
		open: isExpanded,
	});

	/** Обработчик клика по кнопке меню */
	const onClickHandler = (e: React.MouseEvent<HTMLLIElement>) => {
		e.stopPropagation();
		if (!!onClick && !!btnRef?.current) {
			onClick({
				left: btnRef.current.offsetLeft,
				top: btnRef.current.offsetTop - 55,
			});
		}
	};

	return (
		<li
			ref={btnRef}
			className={itemClasses}
			style={{ backgroundColor: color ? color : '' }}
			onClick={(e) => {
				return onClickHandler(e);
			}}
		>
			<Hint placement="right" messageText={title}>
				<button className="menu_item-wrapper">
					<div className="menu_item-wrapper-inner">
						<MenuRight className="menu_item__arrow" />
						<span
							className={'menu-icon ' + iconClass}
							style={{ color: 'white' }}
						/>
					</div>
					<span className={titleClasses}>{title}</span>
					{isWait && (
						<span
							className="rdc_small_spiner"
							style={{
								marginLeft: '1rem',
								color: 'white',
								backgroundColor: 'white',
							}}
						/>
					)}
				</button>
			</Hint>
		</li>
	);
};
